"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
const AuthServiceStub_1 = require("./AuthServiceStub");
const AuthServiceLive_1 = require("./AuthServiceLive");
class AuthService {
    static create(stub) {
        if (stub) {
            return new AuthServiceStub_1.AuthServiceStub();
        }
        // eslint-disable-next-line no-undef
        return new AuthServiceLive_1.AuthServiceLive(window.config.FIREBASE_AUTH_CONFIG);
    }
}
exports.AuthService = AuthService;
//# sourceMappingURL=AuthService.js.map